//import packages from node modules
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux"
import moment from "moment"
import 'moment/locale/en-au'
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import renderHTML from 'react-render-html'
import {reduxForm,change, Field, submit} from "redux-form"

//import utility functions
import {

  moveLiveChatStyling,
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from "../../../utilities/function/common"

import {
    getDataFromSuccessResponse,
    isResponseCancelled,
} from '../../../utilities/function/apiResponse'

import {
    getDataFromURL
} from "../../../utilities/function/urlparams";

import {getAppConfigValue} from "../../../utilities/function/configuration"

import { getErrorFromFailResponse } from "../../../utilities/errors/payinvoice-withref"
import { requiredFieldValidation } from "../../shared/form/validation"
import PAYINVOICE_API from "../../../utilities/api/payinvoice"
import PaymentOptions from "../../shared/paymentoptions"
import { updatePopupNotification } from "../../../app/action"

//import shared components
import Loading from "../../shared/loading"
import InvoiceDetails from "../../shared/invoicedetails"
import SolidButton from "../../shared/button/solidbutton"
import Tabs from "../../shared/tabs"
import TextField from "../../shared/form/textfield"
import loadGoogleRecaptcha from '../../shared/googlerecaptcha'

//define internal functions
export const minCurrencyValue = (min, value) => {
  if (!value) {
    return undefined;
  }
  let _value = parseInt(value.toString().replace("$", ""));
  return _value > min ? true : false;
};
export const maxCurrencyValue = (max, value) => {
  if (!value) {
    return undefined;
  }
  let _value = parseInt(value.toString().replace("$", ""));
  return _value < max ? true : false;
};

let PayInvoicePayPal = (props) => {
  const encode = (value) => {
    if (value){
    return window.btoa(value)
    } 
    return ''
  }
  let { billing_email, invoice_id, amountToPay, maxAmountToPay } = props
  let getUrl = window.location;
  let baseURl = (getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1])
  let redirect = baseURl
  + `?a=pay&step=success&ref=${invoice_id}&p=${encode(amountToPay)}&atp=${encode(maxAmountToPay)}`;
  return (<>
      <form id="paypal-checkout" action="https://www.paypal.com/cgi-bin/webscr" method="post">
        <input type="hidden" name="cmd" value="_xclick" />
        <input type="hidden" name="business" value={`${billing_email}`} />
        <input type="hidden" name="item_name" value={`${getAppConfigValue('company_name')} - Invoice # ${invoice_id}`} />
        <input type="hidden" name="custom" value={`${invoice_id}`} />
        <input type="hidden" name="invoice" value={`${invoice_id}`} />
        <input type="hidden" name="amount" value={`${amountToPay}`} />
        <input type="hidden" name="no_shipping" value="1" />
        <input type="hidden" name="no_note" value="1" />
        <input type="hidden" name="currency_code" value="AUD" />
        <input type="hidden" name="lc" value="AU" />
        <input type="hidden" name="bn" value="PP-BuyNowBF" />
        <input type="hidden" name="rm" value="2" />
        <input type="hidden" name="return" value={redirect} />
        <input type="hidden" name="rm" value="1"/>
      </form></>
  )
}

PayInvoicePayPal.propTypes = {
    billing_email: PropTypes.any,
    invoice_id: PropTypes.any,
    amountToPay: PropTypes.any,
    maxAmountToPay: PropTypes.any
}



let PayInvoiceForm = (props) => {
  const { handleSubmit, form, dispatch, updateAmountToPay } = props
  const { maxAmountToPay = props.maxAmountToPay ? props.maxAmountToPay : 0 } = props
  const [renderField, setRenderField] = useState(false)


  const onFocusOutNormalize = (field) => {
    let minValue = 1.00

    if(field && field.current){
      const value = field.current.value
      const name = field.current.name
      let final 
      if(value && parseFloat(value) && (parseFloat(value) <= parseFloat(maxAmountToPay)) ){
         if (parseFloat(value) < minValue){
            final = parseFloat(minValue)
         } else {
         final = parseFloat(value)
         }
       }else{
         final= parseFloat(maxAmountToPay)
       }
       let str_final = final.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
       updateAmountToPay(str_final)
       dispatch(change(form,name,str_final))
    }
  }

  const onChangeNormalize = (field) => {
    let minValue = 1.00
    if(field){
      const value = field
      let final 
      if(value && parseFloat(value) && (parseFloat(value) <= parseFloat(maxAmountToPay)) ){
         if (parseFloat(value) < minValue){
            final = parseFloat(minValue)
         } else { final = parseFloat(value) }
       } else if (value === ''){
         updateAmountToPay('')
         return
       } else if ( value === '0' || parseFloat(value) === 0){
         updateAmountToPay(minValue)
         return minValue
       } else { final = parseFloat(maxAmountToPay).toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS) }
       if (!/^[0-9]+(\.[0-9]{1,2})?$/g.test(value)) {
        final = final.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)
       }
       let str_final = final
       updateAmountToPay(str_final)
       return str_final
    }
  }


  let list = [
    {
      label: (
        <div className={"of-checkout-payment-form-tab"}>
          <span className={"of-checkout-payment-form-tab__text"}>
            Pay full Amount
          </span>
          <div className={ "of-checkout-payment-form-tab__text of-checkout-payment-form-tab__text--amount" } >
            ${maxAmountToPay.toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}
          </div>
        </div>
      ),
      onClick: () => {
        setRenderField(false);
        updateAmountToPay(maxAmountToPay)
      },
    },
    {
      label: (
        <div className={"of-checkout-payment-form-tab"}>
          <span className={"of-checkout-payment-form-tab__text"}>
            Pay another amount
          </span>
        </div>
      ),
      onClick: () => {
        setRenderField(true)
      },
    },
  ]

  const Disclaimer = () => {
    return (
      <div className="of-amount__additional-wrapper">
        <span className="of-amount__additional--bold">Please note: </span>
        <span className="of-amount__additional">
          {`In order for the product(s)/service(s) within this invoice to provision/renew, payment is
       required in full. If your invoice contains numerous services and you wish to cancel a service prior to 
       payment, please do so within VIPControl in order to have the service removed from your invoice.`}
        </span>
      </div>
    );
  };
  return (
    <>
      {/* {<img src={getOrderFailURL()} alt={'Order Fail'} className={'of-checkout-orderfail__image'}/>} */}
      <form onSubmit={handleSubmit}>
        <PaymentOptions
          getUser={{}}
          form={form}
          dispatch={dispatch}
          isPayInvoice={true}
          withRef={true}
          goBack={false}
        />
        <div className="of-amount__heading text-font-1-100">Amount</div>
        <Tabs className={"of-amount__tabs"} list={list} init={() => {}} />

    
        {renderField ? (
          <div className="of-checkout-payment__half">
            <Field
              form={form}
              dispatch={dispatch}
              label={"Enter the amount you wish to pay"}
              inputMode="numeric"
              validate={[requiredFieldValidation]}
              name={"amount_to_pay"}
              component={TextField}
              placeholder={"Amount"}
              type="number"
              normalize = { onChangeNormalize }
              onFocusOut= { onFocusOutNormalize }
            />
          </div>
        ) : (
          <></>
        )}
        {renderField ? <Disclaimer /> : <></>}
      </form>
    </>
  );
};

PayInvoiceForm = withRouter(PayInvoiceForm);

PayInvoiceForm.propTypes = {
  handleSubmit: PropTypes.func,
  form: PropTypes.any,
  dispatch: PropTypes.any,
  history: PropTypes.object,
  location: PropTypes.object,
  maxAmountToPay: PropTypes.any,
  updateAmountToPay: PropTypes.any
}

PayInvoiceForm = reduxForm({
  form: "PaymentForm",
})(PayInvoiceForm)

let PayInvoiceWithRef = (props) => {

  // Selectors and Dispatch
  const dispatch = useDispatch()

  // Props
  const { location, history } = props;
  const { a, step, postcode, ref, p, atp } = getDataFromURL(location.search);
  
  // Null State Objects
  const nullInvoiceDetails = {
    "url": "",
    "invoices": {
        "id": 0,
        "amount_due": '',
        "due_date": ''
    }
  }
  // States 
  const [getInvoiceDetails, setInvoiceDetails] = useState(nullInvoiceDetails);
  const [getAmountToPay, setAmountToPay] = useState('')
  const [loadedStatus, setloadedStatus] = useState({status: ''});
  const [successfulPayment, setSuccessfulPayment] = useState({success: true, invoice_id: '', eft: false, amount_due: null});


  // Invoice Details
  const invoice_id = ref; 
  const post_code = postcode; 
  
  const executeGoogleRecaptcha = () => {
    let SITE_KEY = getAppConfigValue('google_site_key')
    setloadedStatus({status: 'loading'})
    loadGoogleRecaptcha(() => {
      window.grecaptcha.ready(function() {
        window.grecaptcha.execute(SITE_KEY, {action: 'submit'}).then(function(token) {
        if (token){
          checkInvoice(invoice_id, post_code, token)
        } else {
          closePage();
          setloadedStatus({status: 'error'}) 
          const fatalError = {
            data: {
              errors:[{
                details: 'Something\'s gone wrong. Please try again later or contact our support team.'
              }]
            }
          }
          updatePopupNotification(dispatch, {
            status: 'error',
            error: fatalError
          })
        }
        });
      });
    });
  }

  // API Request 
  const checkInvoice = (invoice_id, post_code, token) => {
    PAYINVOICE_API.checkInvoice(invoice_id, post_code, null, token).then(successresponse => {
      var data = getDataFromSuccessResponse(successresponse)
      if (data){
      //Format Date
      try {
      moment.locale('en-au');        
      data = {
        ...data,
        invoices:{
          ...data.invoices,
          due_date: moment(data.invoices.due_date, "YYYY-MM-DD HH:mm:ss").format('L') 
        }
      }
    } catch (e) {
      data = {
        ...data,
        invoices:{
          ...data.invoices,
          due_date: '' 
        }
      }
    }

    setInvoiceDetails(data) // Set InvoiceDetails State 
    setAmountToPay(data.invoices.amount_due)
    }
      setloadedStatus({status: 'success'}) 
    }, errorresponse => {
      const error = getErrorFromFailResponse(errorresponse)
      setloadedStatus({status: 'error'})
      if (!isResponseCancelled(error)) {
        closePage();
        updatePopupNotification(dispatch, {
          status: 'error',
          error
        })
      }
  })
  }


    // Run if on PayInvoice Page
    if (loadedStatus.status === '' && a === "pay" && step === "payinvoice") {
      executeGoogleRecaptcha()// => checkInvoice
    }

        // Run if on PayInvoice Page
        if (loadedStatus.status === '' && a === "pay" && step === "success") {
          executeGoogleRecaptcha()// => checkInvoice
        }


    const updateAmountToPay = (value) => {
      setAmountToPay(value);
    }

    const closePage = () => {
      history.push(`${history.location.pathname}`);
    }


    const decode = (value) => {
      if (value){
        return window.atob(value)
      } 
      return ''
    }


  const RenderPayNavigation = () => {
    if (getAmountToPay){
      return (
        <div className={"of-cart-main-cta clearfix"}>
          <div className={"of-cart-main-cta__total-wrapper"}>
            <div className={"of-cart-main-cta__label text-font-3-100"}>
              Total Amount
            </div>
            <span className="of-cart-main-cta__total-after text-font-1-100">
            {`$${getAmountToPay.toLocaleString(LOCALE_LANG_OPTIONS, LOCALE_STRING_OPTIONS)}`}
            </span>
          </div>
          <SolidButton
            onClick={() => {
              dispatch(submit('PaymentForm'))
            }}
            isSecondary={true}
            className={"of-cart-main-cta__button text-font-1-100"}
          >
            <i className={"of-cart-main-cta__button-icon icon-of-lock"} />
            Pay Invoice
          </SolidButton>
        </div>
      );
    }
    return <></>
  }

  const moveLiveChat = () => {
    return (renderHTML(moveLiveChatStyling(lcMaximized)))
  }

  const [lcMaximized, setLcMaximized] = useState(false)
  useEffect(() => {
    const onVisibilityChanged = (data) => {
      switch (data.visibility) {
        case 'maximized':
          setLcMaximized(true);
          break
        case 'minimized':
          setLcMaximized(false);
          break
        case 'hidden':
          setLcMaximized(false);
          break
        default:
          break
      }
    }
    
    try {
    window.LiveChatWidget.on('visibility_changed', function(data){
      onVisibilityChanged(data);
    })
    window.LiveChatWidget.off('visibility_changed', function(data){
      onVisibilityChanged(data);
    })
    } catch(e){ console.log(e) }
  },[lcMaximized])

  const [lastDigits, setLastDigits] = useState('');
  const handlePayInvoice = (values, dispatch) => {
    const { payment_option } = values
    if (payment_option === 'New Credit Card') {
    const { url } = getInvoiceDetails
    const amount = getAmountToPay
    const {
      card_number,
      card_cvv,
      card_date,
      card_holder_name,
    } = values; //card_type,
    setLastDigits(card_number.substr(card_number.length - 4));

    const card_date_string = card_date.split("/");
      let payload = {
        invoice_id,
        post_code,
        payment_option: 'Credit Card',
        card_number,
        card_year: card_date_string[1],
        card_month: card_date_string[0],
        card_cvv,
        card_holder_name,
        amount
      };

      // Pay With Credit Card
      setloadedStatus({status: 'loading'})
      PAYINVOICE_API.payInvoice(url, payload).then(successresponse => {
        const data = getDataFromSuccessResponse(successresponse)
        let amount_due;
        try { amount_due  = data.invoice.amount_due } catch(e) {console.log(e)}
        let success = { success: true, invoice_id, eft:true, amount_due}
        setSuccessfulPayment(success)
        setloadedStatus({status: 'success'})
      }, errorresponse => {
        setloadedStatus({status: 'error'})
        const error = getErrorFromFailResponse(errorresponse)
        if (!isResponseCancelled(error)) {
          updatePopupNotification(dispatch, {
            status: 'error',
            error
          })
        }
      })
  } else if (payment_option === 'PayPal'){
    document.getElementById("paypal-checkout").submit();
  }


  }; //ref === successfulPayment.invoice_id &&
  if ((ref === successfulPayment.invoice_id && successfulPayment.success) 
        || (a === "pay" && step === "success")) {
          let amountPayable;
            if (atp && p && getInvoiceDetails.invoices.amount_due){
            try {
            if (parseInt(getInvoiceDetails.invoices.amount_due) === parseInt(decode(atp)) || parseInt(getInvoiceDetails.invoices.due_date) === parseInt(decode(p))){
              amountPayable = parseInt(decode(atp)) -  parseInt(decode(p))
            } else {
              history.push(`${history.location.pathname}`);
            }
            } catch (e) { amountPayable = null}
          }
          let getUrl = window.location;
          let baseURl = (getUrl.protocol + "//" + getUrl.host )

          const sideBarInvoice = (mobile = false) => {
            return (
              <aside className={`of-finished__sidebar of-finished-sidebar${mobile ? '--mobile' : ''}`}>
         <div className="of-finished-sidebar-item">
            <div className="of-finished-sidebar-item__heading text-font-2-100">Payment Deatils</div>
            <ul className="of-finished-sidebar-item__list">
               <li>
                  <div className="label text-font-3-100">Invoice Number</div>
                    <div className="value text-font-2-100">#{ref}</div>
               </li>
               <li>
                  <div className="label text-font-3-100">Payment Type</div>
                  <div className="value text-font-2-100">
                    { successfulPayment.eft ? 'EFT' : 'PayPal'}
                    </div>
               </li>
               { successfulPayment.eft && lastDigits && lastDigits.length > 0 &&
               <li>
                  <div className="label text-font-3-100">Credit Card</div>
                  <div className="value text-font-2-100">
                     **** **** **** {lastDigits}
                    </div>
               </li>
              }
               <li>
                  <div className="label text-font-3-100">Amount Paid</div>
                  <div className="value text-font-2-100">
                  { successfulPayment.eft ? `$${getAmountToPay}` : `$${decode(p)}`}
                  </div>
               </li>
               <li>
                  <div className="label text-font-3-100">Payment Date</div>
                  <div className="value text-font-2-100">
                    {moment().format('L') }
                  </div>
               </li>
               <br/>
               {amountPayable &&  !successfulPayment.eft? <li>
                  <div className="label text-font-3-100">Amount Payable</div>
                  <div className="value text-font-2-100">{ `$${amountPayable.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}` }</div>
               </li> : <></>}
               {successfulPayment.amount_due &&  successfulPayment.eft? <li>
                  <div className="label text-font-3-100">Amount Payable</div>
                  <div className="value text-font-2-100">{ `$${successfulPayment.amount_due}` }</div>
               </li> : <></>}
               <li>
                  <div className="label text-font-3-100">Due Date </div>
                  <div className="value text-font-2-100">{ getInvoiceDetails.invoices.due_date }</div>
               </li>
            </ul>
         </div>
      </aside>
            )
          }

    return (
      <>
<div className="of-page of-checkout-page of-checkout-page--finished">
   <div className="of-checkout-header">
      <div className="of-checkout-header__column of-checkout-header__column--heading">
         <div className="of-checkout-header__heading">
            <div className="of-checkout-header__heading-icon-of-wrapper status-background-1-100"><i className="of-checkout-header__heading-icon icon-of-tick-solid"></i></div>
            <div className="of-checkout-header__heading-text text-font-1-100">Paid!</div>
         </div>
      </div>
      <div className="of-checkout-header__column of-checkout-header__column--keepshopping">
        <button onClick={ closePage }className="of-keep-shopping-button reset-button of-checkout-header__button text-font-3-100 lines-border-1-100">
          <span className="text">Go Back</span><i className="icon icon-of-blog-close"></i>
          </button></div>
   </div>
   <div className="of-finished">
      <div className="of-finished__main">
         <div className="of-finished__wrapper">
            <div className="of-finished-header">
               <img src="https://ventraip.com.au/wp-content/uploads/2020/07/order-success-vipau.svg" className="of-finished-header__image" alt="Thanks All Good"/>
               <div className="of-finished-header__heading text-font-1-100">
                 Thanks<br/>
                 We received your payment!
               </div>
               <div className="of-finished-header__button-wrapper">
                 <a href={`${baseURl}`}>
                 <button type="button" className="of-solid-button of-finished-header__button checkout-sidebar-background-1-100 primary-background-2-100">
                   Back to Website
                   </button>
                   </a>

                   {/* Add Close Button Action */}
                   </div>
                   <div onClick={ closePage } className="of-checkout-payment-success__pay-another checkout-sidebar-font-1-100">
                     Or pay another invoice
                   </div>
            </div>
            {sideBarInvoice(true)}
            <div className="of-finished-description of-checkout-payment-success__whats-next">
               <div className="of-finished-description__item">
                  <div className="of-finished-description__title text-font-2-100">
                    What happens next?
                  </div>
                  <div className="of-finished-description__text text-font-3-100">
                  Payment confirmation and receipt of payment will be delivered via email 
                  to the account holder and listed billing contacts of the account this invoice resides in.
                    </div>
               </div>
            </div>
         </div>
      </div>
      {sideBarInvoice()}
   </div>
</div>
      </>
    );
  } else if (a === "pay" && step === "payinvoice") {
    return (
      <>
      {moveLiveChat()}
        <div className={`of-page of-checkout-page of-checkout-page--payment`}>
          <div
            className={`of-checkout-payment clearfix${
              loadedStatus.status === "loading"
                ? " of-checkout-payment--loading"
                : ""
            }`}
          >
            <div className="of-checkout-payment__header">
              <div className="of-checkout-payment__header__heading">
                <i className="of-checkout-payment__header__icon primary-background-1-100 icon-of-pay-invoice1" />
                <span className="of-checkout-payment__header__text text-font-1-100">
                  Pay an Invoice
                </span>
              </div>
              <div className="of-checkout-header__column of-checkout-header__column--keepshopping">
        <button onClick={ closePage }className="of-keep-shopping-button reset-button of-checkout-header__button text-font-3-100 lines-border-1-100">
          <span className="text">Go Back</span><i className="icon icon-of-blog-close"></i>
          </button></div>
            </div>
            
            <div className={"of-checkout-payment-form of-checkout-form"}>
              <div className={`of-checkout-payment-form__wrapper`}>
                 <InvoiceDetails 
                    invoice_id={ref} 
                    total = { getInvoiceDetails.invoices.amount_due }
                    due = { getInvoiceDetails.invoices.due_date }
                 /> 
                 <PayInvoiceForm 
                    onSubmit={handlePayInvoice}
                    maxAmountToPay={getInvoiceDetails.invoices.amount_due} 
                    updateAmountToPay = { updateAmountToPay }
                 /> 
                 <PayInvoicePayPal
                 billing_email = {'int-billing@ventraip.com.au'}
                 invoice_id = { invoice_id } 
                 amountToPay = { getAmountToPay }
                 maxAmountToPay = { getInvoiceDetails.invoices.amount_due }
                 postcode = { postcode }
                 location = { location }
                 history = { history }
                 />
                 <RenderPayNavigation /> 
              </div>
            </div>
          </div>
          {loadedStatus.status === "loading" ? (
            <Loading wrapper={true} />
          ) :  <></> }
 
        </div>
      </>
    );
  }  
  return <></>;
}

PayInvoiceWithRef.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any,
}

PayInvoiceWithRef = withRouter(PayInvoiceWithRef)

export default PayInvoiceWithRef
